import classnames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

import { Group } from '../../../models/Group'
import useRoutes from '../../../state/useRoutes'
import GroupAvatar from '../../GroupAvatar/GroupAvatar'

import styles from './GroupSlug.module.scss'

export default React.memo(function GroupSlug({
  group,
}: {
  group: Group & { isMember?: boolean; isGroupManager?: boolean }
}) {
  const routes = useRoutes()

  const className = classnames(styles.GroupSlug, {
    skeleton: group.isDummy,
    [styles.isMember]: group.isMember,
    [styles.isGroupManager]: group.isGroupManager,
  })

  return (
    <Link to={routes.manageGroup.url({ uuid: group.uuid })} className={className}>
      <GroupAvatar group={group} className={styles.avatar} />
      <span>{group.name}</span>
    </Link>
  )
})
